<template>
  <div id="newGoodMainPicture" class="main-picture" style="position: relative;">
    <img style='position: absolute;left:0;top:0;  width: 6.08rem; height: 8.9rem;' src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/activity/renewed_bg.png" alt="">
    <div style="position: absolute; left:0;top:0" class="main-picture">
      <div>
        <div class="main-title">以旧换新选海尔，多快好省焕新家</div>
        <p class="main-mdname" v-if="isShopKeeper">{{ shopInfo.name }}</p>
      </div>
      <div class="main-pic">
        <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/activity/renewed_logo.png" alt="">
      </div>
      <div class="main-footer">
        <div class="footer-flex">
          <div class="flex-img">
            <img v-if="canvasSrc" :src="canvasSrc" alt="">
            <!-- <div class="flex-bgimg" :style="{ 'background-image': `url(${canvasSrc})` }"></div> -->
          </div>
          <div class="flex-info">
            <p>海尔官方小程序</p>
            <p>长按二维码查看活动详情</p>
          </div>
        </div>
        <!-- <div class="footer-tips" v-if="isShopKeeper">{{ `「张应华 18134525667」为您推荐` }}</div> -->
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import personalApi from '@/http/service/index'
import html2canvas from 'html2canvas'
import { getClientSunCode } from '@/http/service/common'

export default {
  name: 'renewedPicture',
  data() {
    return {
      canvasSrc: '',
    }
  },
  computed: {
    ...mapState({
      shopInfo: state => state.common.shareStoreInfo
    }),
    ...mapGetters('mymanage', ['getCurrentRole']),
    ...mapGetters(['mId', 'accessToken']),
    isShopKeeper() {
      return this.$util.isShopKeeper()
    },
  },
  async mounted() {
    this.$toast.loading({
      forbidClick: true,
      message: '加载中...',
      duration: 0
    })
    await Promise.all([
      this.getShopQrCode()
    ]).then(() => {
      console.log('all end==============>')
      this.$nextTick(async () => {
        try {
          let imgUrl = await this._html2canvas()
          // this.$util.logColor('imgUrl', 'green', imgUrl)
          this.setShareWxTMImgBase64(imgUrl)
          this.$emit('picFinish')
          this.$toast.clear()
        } catch (error) {
          this.$util.logColor('canvashtml', 'green', error)
          this.$toast.clear()
        }
      })
    }).catch(e => {
      console.log('all catch')
      this.$toast.clear()
    })
  },
  methods: {
    ...mapMutations('common', ['setShareWxTMImgBase64']),
    async getShopQrCode() {
      const query = {}
      let originUrl = window.location.href
      if (this.$util.isShopKeeper()) {
        query.storeId = this.shopInfo.storeId
        query.mdCode = this.shopInfo.mdCode
        // if (this.mId) query.shareId = this.mId
        // query.open_source = 'haier-app-shopKeeper-shared'
        // if (this.getCurrentRole?.userIdentity) query.shareRole = this.getCurrentRole.userIdentity
        // query.linkType = 'share'
        // query.sharePlatform = 'WechatTimeLine'

        let paramUrl = new URL(originUrl)
        if (paramUrl.searchParams.has('mdCode')) { //已有mdcode
          paramUrl.searchParams.set('mdCode', query.mdCode)
        } else {
          paramUrl.searchParams.append('mdCode', query.mdCode)
        }
        query.src = encodeURIComponent(paramUrl.href)
        console.log('query===>', query)

        const params = {
          appid: this.$util.getQrAppid(),
          miniProgName: 'WX_PRIVATE',
          type: 'MINI_PROGRAM_CODE',
          contentUrl: 'pages/webview/webview',
          extra: {
            ...query,
            needShareId: 0,
            // source_type: 'PYQ',
            // source_code: this.$util.getBackEndChannelId(),
          },
          envVersion: this.$util.isProdEnv() ? 'RELEASE' : 'TRIAL',
          width: '400',
          hyaline: false,
          checkPath: this.$util.isProdEnv()
        }
        return personalApi.genreateQr(params).then(res => {
          console.log('genreateQr========111=======>', res.data)
          if (res?.data?.success) {
            this.canvasSrc = res?.data?.data?.fileLink
          } else {
            this.$toast('获取门店信息码失败')
          }
        }).catch(res => {
          this.$toast('请求失败，请重试')
        })
      } else if (this.$util.isHaierApp()) {
        let defaultIMG = 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/activity/renewed_logo.png'
        const appInfo = await this.$util.getAppInfo()
        const { data } = await getClientSunCode({
          appId: "wxe24b2f1f4e378891", //智家APP小程序
          scene: `src=${encodeURIComponent(originUrl)}&title=以旧换新选海尔，多快好省焕新家&needShareId=0&shareImg=${defaultIMG}`,
          page: "subPageMall/webview/webview",
          envVersion: this.$util.isProdEnv() ? "release" : 'trial',
          // envVersion: 'release',
          qrWidth: 500
        }, {
          appId: appInfo?.appId || '',
          appVersion: appInfo?.appVersion || '',
          clientId: appInfo?.clientId || '',
          timestamp: new Date().getTime(),
          accountToken: this.accessToken
        })
        console.log('genreateQr========222=======>', data)
        if (data.retCode === '00000') {
          this.canvasSrc = data.data.data
        } else {
          this.$toast('获取信息码失败')
        }
        return Promise.resolve(true)
      }

    },

    shareContent() {
      return document.getElementById(`newGoodMainPicture`)
    },
    _getPixelRatio(context) {
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1
      return (window.devicePixelRatio || 1) / backingStore
    },
    _html2canvas() {
      return new Promise((resolve, reject) => {
        // 创建一个新的canvas
        const _canvas = this.shareContent()
        this.$util.logColor('_canvas', 'blue', _canvas)
        // 此处用于解决截图不清晰问题，将生成的canvas放大，然后再填充到原有的容器中就会清晰
        const width = _canvas.offsetWidth
        const height = _canvas.offsetHeight
        const canvas2 = document.createElement('canvas')
        const ctx = canvas2.getContext('2d')
        const ratio = this._getPixelRatio(ctx)
        const scale = ratio
        canvas2.width = width * scale
        canvas2.height = height * scale
        ctx.scale(scale, scale)
        const opts = {
          scale: 1,
          canvas: canvas2,
          logging: true, // 日志开关，便于查看html2canvas的内部执行流程
          width,
          height,
          allowTaint: true,
          useCORS: true, // 【重要】开启跨域配置
        }
        html2canvas(_canvas, opts).then(async canvas => {
          const context = canvas.getContext('2d')
          // 【重要】关闭抗锯齿
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false

          const screenUrl = canvas.toDataURL('image/png')
          console.log('screenUrl', screenUrl)
          resolve(screenUrl)
        }).catch(e => { console.log(e) });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main-picture {
  display: flex;
  flex-direction: column;
  width: 6.08rem;
  height: 8.9rem;
  padding: 1.08rem .32rem 0;
  box-sizing: border-box;
  // background: #fff url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/activity/renewed_bg.png) no-repeat;
  background-size: cover;
  border-radius: .32rem;
}

.main-title {
  margin-bottom: .12rem;
  font-size: .36rem;
  font-family: PingFangSC-Medium;
  color: #333333;
  white-space: nowrap;
}

.main-mdname {
  font-size: .28rem;
  font-family: PingFangSC-Regular;
  color: #333333;
}

.main-pic {
  margin-top: .28rem;
  width: 5.42rem;
  height: 4.06rem;
  box-sizing: border-box;
  border: 2px solid rgba(255, 255, 255, 0.80);
  border-radius: .32rem 0 .32rem 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.main-footer {
  margin-top: .32rem;
  flex: 1;
  position: relative;
  padding-bottom: .7rem;
  box-sizing: border-box;
}

.footer-flex {
  display: flex;
}

.flex-img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.6rem;
  height: 1.6rem;
  // padding: .2rem;
  overflow: hidden;
  border-radius: 0.8rem;
  box-sizing: border-box;

  img {
    width: 1.6rem;
    height: 1.6rem;
  }

  .flex-bgimg {
    // background-size: contain;
    width: 1.6rem;
    height: 1.6rem;
    background-repeat: no-repeat;
  }
}

.flex-info {
  height: 1.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: .24rem;
  font-size: .24rem;
  color: #333333;
  font-family: PingFangSC-Regular;

  p {
    margin-bottom: 2px;
  }
}


.footer-tips {
  position: absolute;
  right: 0;
  bottom: .15rem;
  font-size: .24rem;
  color: #fff;
}
</style>